export default __webpack_public_path__ + "static/media/programmer.e5695cb0.png";